import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoFiltro from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/documento/IDocumentoFiltro';

interface ICampoCodigoDocumentoPredecesorProps {
    manejarCambioFiltro: (
        nombreFiltro: keyof IDocumentoFiltro,
        nuevoValor: IDocumentoFiltro[keyof IDocumentoFiltro]
    ) => any;
    valor: string;
}

const CampoCodigoDocumentoPredecesor: FunctionComponent<ICampoCodigoDocumentoPredecesorProps> = ({
    manejarCambioFiltro,
    valor,
}) => (
    <TextField
        fullWidth
        label={<Texto id="Documentos.CampoCodigoDocumentoPredecesor" />}
        onChange={(event) => manejarCambioFiltro('CodigoDocumentoPredecesor', event.target.value)}
        value={valor}
        id={`CampoCodigoDocumentoPredecesor-${valor}`}
    />
);

export default CampoCodigoDocumentoPredecesor;
